/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Uuid } from "../../../../gen/uuid_util/uuid";
import { AddSubjectCamVertexRequest, FullMappingRequest } from "../../../nav_cam_reconstruction/nav_cam_reconstruction";

export const protobufPackage = "skills";

export interface QueueMissionNcpgTask {
  ncpgFileId: Uuid | undefined;
}

export interface NcpgControlActionArgs {
  /**
   * Publish a full mapping request. Wait for a successful response (and fail the action if the
   * response is unsuccessful)
   */
  fullMappingRequest?:
    | FullMappingRequest
    | undefined;
  /**
   * Request the MissionNcpgTask be queued, which tars up the mapping pose graph. The action
   * completes when the task is observed as having been queued.
   */
  queueMissionNcpgTask?: QueueMissionNcpgTask | undefined;
  addSubjectCamVertexRequest?:
    | AddSubjectCamVertexRequest
    | undefined;
  /** How long to wait for the action to complete before failing. Does not apply if <= 0. */
  timeoutS: number;
}

export interface NcpgControlResultData {
}

export interface NcpgControlActionStateData {
}

function createBaseQueueMissionNcpgTask(): QueueMissionNcpgTask {
  return { ncpgFileId: undefined };
}

export const QueueMissionNcpgTask = {
  encode(message: QueueMissionNcpgTask, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ncpgFileId !== undefined) {
      Uuid.encode(message.ncpgFileId, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): QueueMissionNcpgTask {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueueMissionNcpgTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.ncpgFileId = Uuid.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QueueMissionNcpgTask {
    return { ncpgFileId: isSet(object.ncpgFileId) ? Uuid.fromJSON(object.ncpgFileId) : undefined };
  },

  toJSON(message: QueueMissionNcpgTask): unknown {
    const obj: any = {};
    if (message.ncpgFileId !== undefined) {
      obj.ncpgFileId = Uuid.toJSON(message.ncpgFileId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QueueMissionNcpgTask>, I>>(base?: I): QueueMissionNcpgTask {
    return QueueMissionNcpgTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueueMissionNcpgTask>, I>>(object: I): QueueMissionNcpgTask {
    const message = createBaseQueueMissionNcpgTask();
    message.ncpgFileId = (object.ncpgFileId !== undefined && object.ncpgFileId !== null)
      ? Uuid.fromPartial(object.ncpgFileId)
      : undefined;
    return message;
  },
};

function createBaseNcpgControlActionArgs(): NcpgControlActionArgs {
  return {
    fullMappingRequest: undefined,
    queueMissionNcpgTask: undefined,
    addSubjectCamVertexRequest: undefined,
    timeoutS: 0,
  };
}

export const NcpgControlActionArgs = {
  encode(message: NcpgControlActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fullMappingRequest !== undefined) {
      FullMappingRequest.encode(message.fullMappingRequest, writer.uint32(10).fork()).ldelim();
    }
    if (message.queueMissionNcpgTask !== undefined) {
      QueueMissionNcpgTask.encode(message.queueMissionNcpgTask, writer.uint32(18).fork()).ldelim();
    }
    if (message.addSubjectCamVertexRequest !== undefined) {
      AddSubjectCamVertexRequest.encode(message.addSubjectCamVertexRequest, writer.uint32(34).fork()).ldelim();
    }
    if (message.timeoutS !== 0) {
      writer.uint32(29).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NcpgControlActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNcpgControlActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.fullMappingRequest = FullMappingRequest.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.queueMissionNcpgTask = QueueMissionNcpgTask.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.addSubjectCamVertexRequest = AddSubjectCamVertexRequest.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NcpgControlActionArgs {
    return {
      fullMappingRequest: isSet(object.fullMappingRequest)
        ? FullMappingRequest.fromJSON(object.fullMappingRequest)
        : undefined,
      queueMissionNcpgTask: isSet(object.queueMissionNcpgTask)
        ? QueueMissionNcpgTask.fromJSON(object.queueMissionNcpgTask)
        : undefined,
      addSubjectCamVertexRequest: isSet(object.addSubjectCamVertexRequest)
        ? AddSubjectCamVertexRequest.fromJSON(object.addSubjectCamVertexRequest)
        : undefined,
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
    };
  },

  toJSON(message: NcpgControlActionArgs): unknown {
    const obj: any = {};
    if (message.fullMappingRequest !== undefined) {
      obj.fullMappingRequest = FullMappingRequest.toJSON(message.fullMappingRequest);
    }
    if (message.queueMissionNcpgTask !== undefined) {
      obj.queueMissionNcpgTask = QueueMissionNcpgTask.toJSON(message.queueMissionNcpgTask);
    }
    if (message.addSubjectCamVertexRequest !== undefined) {
      obj.addSubjectCamVertexRequest = AddSubjectCamVertexRequest.toJSON(message.addSubjectCamVertexRequest);
    }
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NcpgControlActionArgs>, I>>(base?: I): NcpgControlActionArgs {
    return NcpgControlActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NcpgControlActionArgs>, I>>(object: I): NcpgControlActionArgs {
    const message = createBaseNcpgControlActionArgs();
    message.fullMappingRequest = (object.fullMappingRequest !== undefined && object.fullMappingRequest !== null)
      ? FullMappingRequest.fromPartial(object.fullMappingRequest)
      : undefined;
    message.queueMissionNcpgTask = (object.queueMissionNcpgTask !== undefined && object.queueMissionNcpgTask !== null)
      ? QueueMissionNcpgTask.fromPartial(object.queueMissionNcpgTask)
      : undefined;
    message.addSubjectCamVertexRequest =
      (object.addSubjectCamVertexRequest !== undefined && object.addSubjectCamVertexRequest !== null)
        ? AddSubjectCamVertexRequest.fromPartial(object.addSubjectCamVertexRequest)
        : undefined;
    message.timeoutS = object.timeoutS ?? 0;
    return message;
  },
};

function createBaseNcpgControlResultData(): NcpgControlResultData {
  return {};
}

export const NcpgControlResultData = {
  encode(_: NcpgControlResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NcpgControlResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNcpgControlResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): NcpgControlResultData {
    return {};
  },

  toJSON(_: NcpgControlResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<NcpgControlResultData>, I>>(base?: I): NcpgControlResultData {
    return NcpgControlResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NcpgControlResultData>, I>>(_: I): NcpgControlResultData {
    const message = createBaseNcpgControlResultData();
    return message;
  },
};

function createBaseNcpgControlActionStateData(): NcpgControlActionStateData {
  return {};
}

export const NcpgControlActionStateData = {
  encode(_: NcpgControlActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NcpgControlActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNcpgControlActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): NcpgControlActionStateData {
    return {};
  },

  toJSON(_: NcpgControlActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<NcpgControlActionStateData>, I>>(base?: I): NcpgControlActionStateData {
    return NcpgControlActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NcpgControlActionStateData>, I>>(_: I): NcpgControlActionStateData {
    const message = createBaseNcpgControlActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
